export enum EcommerceStoreYearlyRevenueOptions {
  Zero = '0',
  Less5k = '<5k',
  From5kTo25k = '5k-25k',
  From25kTo50k = '25k-50k',
  From50To100k = '50k-100k',
  From100To500k = '100k-500k',
  Above500k = '>500k',
}
